var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_green_close",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#27AE60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_green_close)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80032 13.9904L4.01001 13.2001L8.21001 9.00008L4.01001 4.80008L4.80032 4.00977L9.00032 8.20977L13.2003 4.00977L13.9906 4.80008L9.79064 9.00008L13.9906 13.2001L13.2003 13.9904L9.00032 9.79039L4.80032 13.9904Z",
    fill: "#27AE60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCloseIcon);
export default __webpack_public_path__ + "static/media/green-close-icon.e0e7c85c74c047cf8e3b5d9083e60ab8.svg";
export { ForwardRef as ReactComponent };